export const ViewEPPIcon = ({ fill = '#fff', hoverFill = '#FAFAFA' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <rect width="24" height="24" transform="translate(0 0.5)" />
      <path
        d="M4 18.5V10.5V10.825V6.5V18.5ZM4 8.5H20V6.5H4V8.5ZM11.575 20.5H4C3.45 20.5 2.97917 20.3042 2.5875 19.9125C2.19583 19.5208 2 19.05 2 18.5V6.5C2 5.95 2.19583 5.47917 2.5875 5.0875C2.97917 4.69583 3.45 4.5 4 4.5H20C20.55 4.5 21.0208 4.69583 21.4125 5.0875C21.8042 5.47917 22 5.95 22 6.5V11.825C21.4167 11.4083 20.7792 11.0833 20.0875 10.85C19.3958 10.6167 18.6667 10.5 17.9 10.5C16.95 10.5 16.0542 10.6792 15.2125 11.0375C14.3708 11.3958 13.6333 11.8833 13 12.5H4V18.5H10.975C11.025 18.85 11.1 19.1917 11.2 19.525C11.3 19.8583 11.425 20.1833 11.575 20.5Z"
        fill={fill}
      />
      <path
        d="M17.8887 21.5V21.1758C16.2422 21.082 15.0469 20.25 15 18.791L15.0059 18.7852H16.5703V18.791C16.6699 19.3887 17.0859 19.7754 17.8887 19.8516V17.748L17.4961 17.6543C15.9668 17.3086 15.1289 16.623 15.1289 15.3633V15.3516C15.1289 13.957 16.2773 13.0781 17.8887 12.9844V12.5H18.5625V12.9844C20.1855 13.1074 21.2461 14.0332 21.3047 15.4102L21.2988 15.416L19.7461 15.4219L19.7402 15.4102C19.6582 14.7832 19.2188 14.4082 18.5625 14.3086V16.3477L18.9785 16.4355C20.5781 16.7988 21.416 17.4434 21.416 18.7266V18.7383C21.416 20.1973 20.2266 21.0586 18.5625 21.1699V21.5H17.8887ZM16.7637 15.2344C16.7637 15.6855 17.0977 15.9785 17.8887 16.1895V14.3027C17.1504 14.3848 16.7637 14.748 16.7637 15.2227V15.2344ZM19.7812 18.9023C19.7812 18.3926 19.4707 18.1289 18.5625 17.9004V19.8574C19.377 19.7812 19.7812 19.4414 19.7812 18.9141V18.9023Z"
        fill={fill}
      />
    </svg>
  );
};

export const RespViewEPPIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="#FAFAFA" />

      <path
        d="M4 18V10V10.325V6V18ZM4 8H20V6H4V8ZM11.575 20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V11.325C21.4167 10.9083 20.7792 10.5833 20.0875 10.35C19.3958 10.1167 18.6667 10 17.9 10C16.95 10 16.0542 10.1792 15.2125 10.5375C14.3708 10.8958 13.6333 11.3833 13 12H4V18H10.975C11.025 18.35 11.1 18.6917 11.2 19.025C11.3 19.3583 11.425 19.6833 11.575 20Z"
        fill={fill}
      />
      <path
        d="M17.8887 21V20.6758C16.2422 20.582 15.0469 19.75 15 18.291L15.0059 18.2852H16.5703V18.291C16.6699 18.8887 17.0859 19.2754 17.8887 19.3516V17.248L17.4961 17.1543C15.9668 16.8086 15.1289 16.123 15.1289 14.8633V14.8516C15.1289 13.457 16.2773 12.5781 17.8887 12.4844V12H18.5625V12.4844C20.1855 12.6074 21.2461 13.5332 21.3047 14.9102L21.2988 14.916L19.7461 14.9219L19.7402 14.9102C19.6582 14.2832 19.2188 13.9082 18.5625 13.8086V15.8477L18.9785 15.9355C20.5781 16.2988 21.416 16.9434 21.416 18.2266V18.2383C21.416 19.6973 20.2266 20.5586 18.5625 20.6699V21H17.8887ZM16.7637 14.7344C16.7637 15.1855 17.0977 15.4785 17.8887 15.6895V13.8027C17.1504 13.8848 16.7637 14.248 16.7637 14.7227V14.7344ZM19.7812 18.4023C19.7812 17.8926 19.4707 17.6289 18.5625 17.4004V19.3574C19.377 19.2812 19.7812 18.9414 19.7812 18.4141V18.4023Z"
        fill={fill}
      />
    </svg>
  );
};

export const ViewServiceRequestIcon = ({
  width = '24',
  height = '25',
  fill = '#fff',
  hoverFill = '#FAFAFA',
}) => {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />

      <path
        d="M20.1668 18.1H12.8333V14.95H16V13.2833H12.8333V10.1168H11.1668V13.2833H8V14.95H11.1668V18.1ZM5.66675 22C5.21675 22 4.82642 21.8348 4.49575 21.5043C4.16525 21.1736 4 20.7833 4 20.3333V3.66675C4 3.21675 4.16525 2.82642 4.49575 2.49575C4.82642 2.16525 5.21675 2 5.66675 2H14.35L20 7.65V20.3333C20 20.7833 19.8348 21.1736 19.5042 21.5043C19.1736 21.8348 18.7833 22 18.3333 22H5.66675ZM13.5167 8.43325V3.66675H5.66675V20.3333H18.3333V8.43325H13.5167Z"
        transform="translate(15, 15)"
        fill={fill}
      />
    </svg>
  );
};

export const RespViewServiceReqIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="white" />
      <path
        d="M11.1668 18.1H12.8333V14.95H16V13.2833H12.8333V10.1168H11.1668V13.2833H8V14.95H11.1668V18.1ZM5.66675 22C5.21675 22 4.82642 21.8348 4.49575 21.5043C4.16525 21.1736 4 20.7833 4 20.3333V3.66675C4 3.21675 4.16525 2.82642 4.49575 2.49575C4.82642 2.16525 5.21675 2 5.66675 2H14.35L20 7.65V20.3333C20 20.7833 19.8348 21.1736 19.5042 21.5043C19.1736 21.8348 18.7833 22 18.3333 22H5.66675ZM13.5167 8.43325V3.66675H5.66675V20.3333H18.3333V8.43325H13.5167Z"
        fill="#1F1F1F"
      />
    </svg>
  );
};

export const NoServiceRequestIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
    >
      <circle
        cx="40.5"
        cy="40"
        r="39"
        fill="white"
        stroke="#CCCCCC"
        stroke-width="2"
      />

      <path
        d="M17.2501 27.15H19.7499V22.425H24.5V19.9249H19.7499V15.1751H17.2501V19.9249H12.5V22.425H17.2501V27.15ZM9.00012 33C8.32512 33 7.73963 32.7521 7.24363 32.2564C6.74788 31.7604 6.5 31.1749 6.5 30.4999V5.50012C6.5 4.82512 6.74788 4.23963 7.24363 3.74363C7.73963 3.24788 8.32512 3 9.00012 3H22.025L30.5 11.475V30.4999C30.5 31.1749 30.2521 31.7604 29.7564 32.2564C29.2604 32.7521 28.6749 33 27.9999 33H9.00012ZM20.7751 12.6499V5.50012H9.00012V30.4999H27.9999V12.6499H20.7751Z"
        fill="#999999"
        transform="translate(22, 21)"
      />
    </svg>
    // <svg
    //   width="56"
    //   height="57"
    //   viewBox="0 0 56 57"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   {/* <circle cx="28" cy="28.5" r="28" fill={"#E9E9E9"} /> */}
    //   <circle
    //     cx="40.5"
    //     cy="40"
    //     r="39"
    //     fill="white"
    //     stroke="#CCCCCC"
    //     stroke-width="2"
    //   />
    //   <rect
    //     width="24"
    //     height="24"
    //     transform="translate(16 16.5)"
    //     fill={'#fffff'}
    //   />

    // </svg>
  );
};

export const RespSendAndViewRequestIcon = ({
  fill = '#fff',
  hoverFill = '#FAFAFA',
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="white" />

      <path
        d="M22 22L18 18H8C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V15H17C17.55 15 18.0208 14.8042 18.4125 14.4125C18.8042 14.0208 19 13.55 19 13V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V22ZM4 12.175L5.175 11H15V4H4V12.175ZM2 17V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H15C15.55 2 16.0208 2.19583 16.4125 2.5875C16.8042 2.97917 17 3.45 17 4V11C17 11.55 16.8042 12.0208 16.4125 12.4125C16.0208 12.8042 15.55 13 15 13H6L2 17Z"
        fill={fill}
      />
    </svg>
  );
};
export const SendAndViewRequestIcon = ({
  fill = '#fff',
  hoverFill = '#FAFAFA',
}) => {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />
      <path
        d="M22 22L18 18H8C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V15H17C17.55 15 18.0208 14.8042 18.4125 14.4125C18.8042 14.0208 19 13.55 19 13V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V22ZM4 12.175L5.175 11H15V4H4V12.175ZM2 17V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H15C15.55 2 16.0208 2.19583 16.4125 2.5875C16.8042 2.97917 17 3.45 17 4V11C17 11.55 16.8042 12.0208 16.4125 12.4125C16.0208 12.8042 15.55 13 15 13H6L2 17Z"
        fill={fill}
        transform="translate(15, 18)"
      />
    </svg>
  );
};
